import { memo } from 'react';
import type { IconProps } from '../../../core/components/icons/types';

const NextIcon = ({ iconLabel, color }: IconProps) => (
    <svg
        width="9"
        height="14"
        viewBox="0 0 9 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-icon-label={iconLabel}
        color={color}
    >
        <path
            d="M1 13L7 7.00083L0.999999 1"
            stroke="currentColor"
            strokeWidth="2"
        />
    </svg>
);

export default memo(NextIcon);
